// src/pages/History/RenaissanceReformation/ItalianRenaissanceGo.jsx
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Renaissance_&_Reformation_-_Italian_Renaissance.png';

export default function HistoryPageItalianRenaissanceGo() {
  return (
    <QuizPage
      title="History: Italian Renaissance"
      subTopic="Italian Renaissance"
      backgroundImage={historyImage}
      returnPath="/History-Italian-Renaissance"
    />
  );
}
